var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12980_22575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.375 4.5H3V5.25H6.375V4.5Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 6.375H3V7.125H4.875V6.375Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 9.75H1.5C1.30116 9.74977 1.11052 9.67068 0.969922 9.53008C0.829319 9.38948 0.750228 9.19884 0.75 9V3C0.750228 2.80116 0.829319 2.61052 0.969922 2.46992C1.11052 2.32932 1.30116 2.25023 1.5 2.25H7.875C8.07384 2.25023 8.26448 2.32932 8.40508 2.46992C8.54568 2.61052 8.62477 2.80116 8.625 3V4.52122L10.6571 3.06997C10.7131 3.02988 10.7791 3.006 10.8479 3.00098C10.9166 2.99596 10.9854 3.00998 11.0467 3.0415C11.1079 3.07303 11.1593 3.12083 11.1952 3.17967C11.2311 3.2385 11.25 3.30609 11.25 3.375V8.625C11.25 8.69391 11.2311 8.7615 11.1952 8.82034C11.1593 8.87918 11.1079 8.927 11.0467 8.95853C10.9854 8.99005 10.9166 9.00408 10.8479 8.99906C10.7791 8.99403 10.7131 8.97016 10.6571 8.93006L8.625 7.47878V9C8.62477 9.19884 8.54568 9.38948 8.40508 9.53008C8.26448 9.67068 8.07384 9.74977 7.875 9.75ZM1.5 3V9.00037L7.875 9V6.75C7.87496 6.68109 7.89391 6.6135 7.92978 6.55466C7.96566 6.49582 8.01705 6.448 8.07833 6.41647C8.13961 6.38495 8.20839 6.37092 8.27712 6.37594C8.34585 6.38097 8.41187 6.40484 8.46791 6.44494L10.5 7.89622V4.10378L8.46791 5.55503C8.41187 5.59512 8.34586 5.619 8.27713 5.62402C8.20841 5.62904 8.13963 5.61502 8.07835 5.5835C8.01707 5.55197 7.96567 5.50417 7.9298 5.44533C7.89392 5.3865 7.87496 5.31891 7.875 5.25V3H1.5Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12980_22575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.9f48ed7e979ece2c52c5ec4f15f2806f.svg";
export { ForwardRef as ReactComponent };